import React from 'react';
import Layout from '../layout';
import DashboardOverview from '../dashboard/components/DashboardOverview';

export default function UsageAnalytics() {
    return (
        <Layout>
            <DashboardOverview />
        </Layout>
    );
}
